import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDownloadWMSReports = () => {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const downloadWMSReports = ({ zoneGuid, zoneTitle }) => {
    axiosClient
      .get(`Inventory/Report/ProductQuntity?Guid=${zoneGuid}`, {
        responseType: 'blob',
      })
      .then(res => {
        if (res.status === 200) {
          const type = res.headers['content-type'];
          const blob = new Blob([res.data], {
            type,
            encoding: 'UTF-8',
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `گزارش موجودی انبار (${zoneTitle}).xlsx`;
          link.click();
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [downloadWMSReports, loading];
};

export default useDownloadWMSReports;
